export const isPlaywright = typeof window !== "undefined" && "Playwright" in window;
export const isTesting = Config.nodeEnv === "test" || Config.e2eTest || isPlaywright;

export const isDevelopment = Config.nodeEnv === "development" && !isTesting;
export const isProduction = Config.nodeEnv === "production" && !isTesting;

// When running playwright tests, we need a run-time test
export const isE2ETest = isPlaywright || Config.e2eTest;
